import { Box, Stack, xcss } from '@atlaskit/primitives';
import React, { FunctionComponent } from 'react';

import { ViewPanelSettingType } from '../../types/types';
import ViewSettingsConfigurationRow from '../viewSettingsConfigurationRow/ViewSettingsConfigurationRow';
import ViewSettingsLayoutTypePicker from '../viewSettingsLayout/ViewSettingsLayoutTypePicker';

import { ViewRename, ViewSettingsOverviewProps } from './ViewRename';

const viewPanelSettingsContainerStyles = xcss({
  listStyle: 'none',
  padding: 'space.0',
  margin: 'space.0',
});

const ViewSettingsOverview: FunctionComponent<ViewSettingsOverviewProps> = ({
  viewNameIsValid,
  viewNames,
  canEditViews,
  viewName,
  setViewName,
}) => {
  return (
    <Stack space="space.300">
      <ViewRename
        viewNameIsValid={viewNameIsValid}
        viewNames={viewNames}
        canEditViews={canEditViews}
        viewName={viewName}
        setViewName={setViewName}
      />

      <ViewSettingsLayoutTypePicker isCompact={true} source="databaseViewSettingsPanel" />

      <Box as="ul" xcss={viewPanelSettingsContainerStyles}>
        {(
          [
            ViewPanelSettingType.LAYOUT,
            ViewPanelSettingType.FILTER,
            ViewPanelSettingType.SORT,
            ViewPanelSettingType.FIELDS,
          ] as const
        ).map((viewSetting) => {
          return (
            <li key={viewSetting}>
              <ViewSettingsConfigurationRow viewSetting={viewSetting} />
            </li>
          );
        })}
      </Box>
    </Stack>
  );
};
export default ViewSettingsOverview;
